import React from 'react';
import { Grid, Card, Typography, Button, Stack, Skeleton, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// import { useApolloClient } from '@apollo/client';
import getConfig from 'next/config';
import VisibilityIcon from '@mui/icons-material/Visibility';
import styles from './styles';
// import { removeCookie, getCookie } from '../../hooks/useCookie';
// import { clearLocalStorage } from '../../hooks/useLocalStorage';
// import { createCrossSellProspect } from '../../integration/cross-sell.api';
// // import ErrorModal from '../eir-error-modal/ErrorModal';
// import { useToggle } from '../../hooks/useToggle';

const { publicRuntimeConfig } = getConfig();

const CrossSellInitiateCard = ({
  card,
  loading = false,
  // setCrossSellCardState,
  // setOfferCardButtonDisable,
  // CSFailed,
}) => {
  const theme = useTheme();
  // const graphql = useApolloClient();
  // const [onCSError, setOnCSError] = useState(false);
  // const errorModal = useToggle(false);
  // const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  // const errorModalMaxOccurence = 4;
  const sm = useMediaQuery(theme.breakpoints.down('sm'));

  const renderContent = content => ({ __html: content });

  // const onInitiateButtonClick = () => {
  //   if (CSFailed) {
  //     setOnCSError(true);
  //     setErrorModalOccurence(errorModalOccurence + 1);
  //     errorModal.enable();
  //     return;
  //   }
  //   setCrossSellCardState(true);
  //   setOfferCardButtonDisable(true);
  // };
  // const clearJourneyAndCreateCrossSell = async () => {
  //   if (CSFailed) {
  //     setOnCSError(true);
  //     setErrorModalOccurence(errorModalOccurence + 1);
  //     errorModal.enable();
  //     return;
  //   }
  //   clearLocalStorage();
  //   removeCookie('cart_Type');
  //   removeCookie('reference');
  //   // setClearJourney(true);
  //   setCrossSellCardState(true);
  //   setOfferCardButtonDisable(true);
  //   const accountId = JSON.parse(getCookie('selected_subscription'))?.accountId;
  //   await createCrossSellProspect({ graphql, accountId, offerType: 'POSTPAY' });
  // };
  return (
    <Grid item xs={11} sm={6.5} md={4.5}>
      <Card sx={styles(theme).addon_cards}>
        <Stack sx={{ textAlign: 'left' }} direction='column'>
          {loading ? (
            <>
              <Skeleton
                variant='rectangular'
                sx={{ m: '0 auto', height: { xs: 90 }, width: { xs: 47 } }}
              />
              <Skeleton height={24} width='50%' sx={{ m: '1rem auto 0' }} />
              <Skeleton height={16} width='60%' sx={{ m: 'auto' }} />
              <Skeleton height={24} width='20%' sx={{ m: '1rem auto 0' }} />
            </>
          ) : (
            <Grid
              container
              xs={12}
              sx={{ flexDirection: 'column', xs: { justifyContent: 'center' } }}
            >
              {sm ? (
                <Grid>
                  <Typography variant='body1' sx={styles(theme).descriptionNew}>
                    View other offers available to you
                  </Typography>

                  <Button
                    variant='buttonMedium'
                    sx={styles(theme).checkOffersButtonNew}
                    onClick={() => {
                      // setCrossSellCardState(true);
                      // setOfferCardButtonDisable(true);
                      // clearJourneyAndCreateCrossSell();
                    }}
                    aria-label='Check for more offers'
                  >
                    Check for more offers
                    <VisibilityIcon sx={styles(theme).visibilityIcon} className='visibilityIcon' />
                  </Button>
                </Grid>
              ) : (
                <Grid container spacing={1}>
                  <Grid item container spacing={1}>
                    <Grid xs={12} item>
                      <Box
                        display={{ xs: 'block', md: 'block' }}
                        component='img'
                        alt={card.altText}
                        src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${card.img}`}
                        sx={{ width: '100%', height: '240px' }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md='auto'
                      sx={[
                        {
                          flex: { md: 1 },
                          marginBottom: '1.5rem',
                        },
                        styles(theme).addonCard_content,
                      ]}
                    >
                      <Typography
                        variant='body1'
                        sx={{
                          paddingTop: 1,
                          paddingRight: 0.5,
                          marginTop: '13px',
                          marginLeft: '7px',
                        }}
                        dangerouslySetInnerHTML={renderContent(card?.bodyDescription)}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md='auto'
                    sx={[
                      {
                        flex: { md: 1 },
                        marginBottom: '2rem',
                      },
                      styles(theme).addonCard_content,
                    ]}
                  >
                    <Button
                      variant='buttonMedium'
                      sx={styles(theme).checkOffersButton}
                      onClick={() => {}}
                    >
                      {card.ctaText}
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid>
          )}
        </Stack>
      </Card>
      {/* <ErrorModal
        errorBBModal={errorModal}
        occurences={errorModalMaxOccurence}
        currentOccurence={errorModalOccurence}
        ctaMethod={onCSError ? clearJourneyAndCreateCrossSell : () => {}}
      /> */}
    </Grid>
  );
};

export default CrossSellInitiateCard;
